import { RoutesPlantillas as CamRoutesPlantillas, RoutesEstado } from '@frontend/metadataadmin/lib/components';
import { Intro } from '@frontend/metadataadmin/lib/components/estadistica/Intro';
import { RoutesEstadistica, RoutesPaquetes } from '@frontend/metadatarequest/lib/components';
import { RoutesCatalogos, RoutesConceptos, RoutesContextos, RoutesPlantillas } from '@frontend/templateadmin/lib/components';
import { RoutesMenu, RoutesServicios, RoutesSesion, RoutesSistemaModulo, RoutesUsuarios } from '@frontend/useradmin/lib/components';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import "react-toastify/dist/ReactToastify.css";
import { Home } from './views/Home';
import { Learning } from './views/Learning';
import { Login } from './views/Login';
import { Page404 } from './views/Page404';
import { Release } from './views/Release';
import { BaseProvider } from '@frontend/templateadmin/lib/general/contexts/BaseProvider';

export const Router = () => {
    const basename = process.env.REACT_APP_BASE_NAME;
    return (
        <BrowserRouter basename={basename}>
            <BaseProvider>
                <Routes>
                    <Route path='/' element={<Navigate to="login" />} />
                    <Route path='/home' element={<Home />}>
                        <Route index element={<Intro />} />
                        <Route path='apm'>
                            <Route index element={<Navigate to="conceptos" />} />
                            <Route path='conceptos/*' element={<RoutesConceptos />} />
                            <Route path='plantillas/*' element={<RoutesPlantillas />} />
                            <Route path='catalogos/*' element={<RoutesCatalogos />} />
                            <Route path='contextos/*' element={<RoutesContextos />} />
                        </Route>
                        <Route path="admin">
                            <Route index element={<Navigate to="usuario" />} />
                            <Route path='usuarios/*' element={<RoutesUsuarios />} />
                            <Route path='servicios/*' element={<RoutesServicios />} />
                            <Route path='sistemamodulo/*' element={<RoutesSistemaModulo />} />
                            <Route path='menu/*' element={<RoutesMenu />} />
                            <Route path='sesion/*' element={<RoutesSesion />} />
                        </Route>
                        <Route path='cam'>
                            <Route index element={<Navigate to="plantilla" />} />
                            <Route path='plantilla/*' element={<CamRoutesPlantillas />} />
                            <Route path='estado/*' element={<RoutesEstado />} />
                        </Route>
                        <Route path='cvm'>
                            <Route index element={<Navigate to="paquete" />} />
                            <Route path='paquete/*' element={<RoutesPaquetes />} />
                            <Route path='estadistica/*' element={<RoutesEstadistica />} />
                        </Route>
                    </Route>
                    <Route path='/login' element={<Login />}></Route>
                    <Route path='/release' element={<Release />} />
                    <Route path='/learning' element={<Learning />} />
                    <Route path='/*' element={<Page404 />} />
                </Routes>
            </BaseProvider>
        </BrowserRouter>
    )
}
